import { render, staticRenderFns } from "./RecruitInfo.vue?vue&type=template&id=e506cea6&scoped=true&"
import script from "./RecruitInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecruitInfo.vue?vue&type=style&index=0&id=e506cea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e506cea6",
  null
  
)

export default component.exports